import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Label: {
    id: 'dzhR0c',
    defaultMessage: 'Printable',
    description: 'Text for the option to select a printable/regular label for a return shipment',
  },
  QrCode: {
    id: '4afw/0',
    defaultMessage: 'QR Code',
    description: 'Text for the option to select a QR code for a return shipment',
  },
  LabelAndQrCode: {
    id: 'Cce7U8',
    defaultMessage: 'Label and QR Code',
    description: 'Text for the option to select both a label and QR code for a return shipment',
  },
  Paperless: {
    id: 'ya3+t4',
    defaultMessage: 'Paperless',
    description: 'Text for the option to select a paperless/barcode label for a return shipment',
  },
  LabelAndPaperless: {
    id: 'BOfaQK',
    defaultMessage: 'Label and Paperless',
    description: 'Text for the option to select both a label and paperless/barcode option for a return shipment',
  },
  NoBoxNoLabel: {
    id: 'l5pQwT',
    defaultMessage: 'No Box No Label',
    description: 'Text for the option to select no box and no label for a return shipment',
  },
});

export const ShipmentLabelType = {
  Label: {
    key: 'Label',
    translation: messages.Label,
  },
  QrCode: {
    key: 'QrCode',
    translation: messages.QrCode,
  },
  LabelAndQrCode: {
    key: 'LabelAndQrCode',
    translation: messages.LabelAndQrCode,
  },
  Paperless: {
    key: 'Paperless',
    translation: messages.Paperless,
  },
  LabelAndPaperless: {
    key: 'LabelAndPaperless',
    translation: messages.LabelAndPaperless,
  },
  NoBoxNoLabel: {
    key: 'NoBoxNoLabel',
    translation: messages.NoBoxNoLabel,
  },
};
